import useTransactionsStore from '@/store/modules/transactions';
import { formatTime } from '@/utils/helpers';
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue';
export default defineComponent({
    name: 'RateTimer',
    emits: ['newRate'],
    setup(props, { emit }) {
        const transactionsStore = useTransactionsStore();
        const timeToNewRate = ref(60);
        const displayTimeRemaining = ref('');
        const intervalId = ref(undefined);
        const updateRates = async () => {
            await transactionsStore.getRates();
            emit('newRate');
        };
        const startTimer = () => window.setTimeout(async () => {
            timeToNewRate.value -= 1;
            displayTimeRemaining.value = formatTime(timeToNewRate.value);
            if (timeToNewRate.value <= 1) {
                if (!document.hidden) {
                    await updateRates();
                }
                timeToNewRate.value = 60; // Reset the timer
            }
            intervalId.value = startTimer();
        }, 1000);
        onMounted(() => {
            updateRates();
            intervalId.value = startTimer();
        });
        onBeforeUnmount(() => {
            clearTimeout(intervalId.value);
        });
        return {
            displayTimeRemaining,
        };
    },
});
